import type { Section } from "@qendo/permissions";
import { useState } from "react";
import { ShareContent } from "~/components/form/team/ShareContent";
import { HeaderButton, type HeaderButtonProps } from "~/components/HeaderButton";
import { Can } from "~/components/permission/Can";

export type ShareButtonProps = {
    title?: string;
    initial?: Section[] | null;
} & Omit<HeaderButtonProps, "onPress" | "href" | "icon">;

export const ShareButton = ({ initial, title = "Share", ...buttonProps }: ShareButtonProps) => {
    const [sharing, setSharing] = useState(false);

    return (
        <Can ability="update" section="team">
            <HeaderButton {...buttonProps} title="Share" icon="share" onPress={() => setSharing(true)} />
            {sharing && <ShareContent title={title} onRequestClose={() => setSharing(false)} initial={initial} />}
        </Can>
    );
};
